// extracted by mini-css-extract-plugin
export default {"root":"_1TdzM","first-row":"_1OhIX","firstRow":"_1OhIX","second-row":"_2La9v","secondRow":"_2La9v"};